module.exports = __webpack_public_path__ + "meet_the_author@2x.jpg";